import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const articleSlugs = [
  'allchinabuy-spreadsheet-guide',
  'allchinabuy-spreadsheet-safety-guide',
  'allchinabuy-spreadsheet-sneakers-guide',
  'allchinabuy-spreadsheet-clothing-guide',
  'allchinabuy-spreadsheet-shipping-guide',
  'allchinabuy-spreadsheet-qc-guide',
  'allchinabuy-spreadsheet-comparison-guide',
  'allchinabuy-spreadsheet-tips-guide',
  'allchinabuy-spreadsheet-budget-guide',
  'allchinabuy-spreadsheet-trends-guide',
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articleSlugs.map((slug): RouteObject => ({
    path: `/${slug}`,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;